import React, {FC, ReactNode} from 'react';
import cn from 'classnames';
import styles from './PageHeader.css';

interface PageHeaderProps {
	className?: string;
	title: ReactNode;
	description?: ReactNode;
	trailing?: ReactNode;
	children?: ReactNode;
}

export const PageHeader: FC<PageHeaderProps> = props => {
	const {className, title, description, trailing, children} = props;

	return (
		<div className={cn(styles.root, className)}>
			<div className={styles.head}>
				<div className={styles.title}>{title}</div>
				{description && <p className={styles.description}>{description}</p>}
			</div>
			<div className={styles.middle}>{children}</div>
			<div className={styles.trailing}>{trailing}</div>
		</div>
	);
};

PageHeader.displayName = 'PageHeader';
